import type { ListBoardItemResponse } from "@/client";
import { shareURL } from "~/modules/shared/utils/shareURL";

export async function shareBoardUrl(
	board: Pick<ListBoardItemResponse, "title">,
): Promise<void> {
	await shareURL({
		title: board.title || "Board",
		copiedDescription:
			"You can paste it into a chat, email, or document to share this board page.",
	});
}
